/**
 * Application.Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type ExchangeId =
  | 'Unknown'
  | 'XASX'
  | 'APX'
  | 'CHIA'
  | 'MFUND'
  | 'ALGO'
  | 'CMCX'
  | 'International'
  | 'XTSX'
  | 'XNAS'
  | 'XASE'
  | 'XNYS'
  | 'XTSE'
  | 'XTKS'
  | 'XJAS'
  | 'XHKG'
  | 'XSES'
  | 'XLON'
  | 'XPAR'
  | 'XMLI'
  | 'ALXP'
  | 'XSWX'
  | 'XVTX'
  | 'TNLA'
  | 'XAMS'
  | 'XBRU'
  | 'MLXB'
  | 'VPXB'
  | 'ALXB'
  | 'XETR'
  | 'XFRA'
  | 'ARCX'
  | 'XNZE'
  | 'OOTC'
  | 'TNLB'
  | 'BATS'
  | 'IEXG'
  | 'XJPX'
  | 'XCNQ'
  | 'XCBO'
  | 'FINR'
  | 'XSTO'
  | 'XMCE'
  | 'FNDK'
  | 'FNSE'
  | 'MABX'
  | 'XCSE'
  | 'FNIS'
  | 'XICE'
  | 'XLAT'
  | 'FOREX'
  | 'ITBIT';

export const ExchangeId = {
  Unknown: 'Unknown' as ExchangeId,
  Xasx: 'XASX' as ExchangeId,
  Apx: 'APX' as ExchangeId,
  Chia: 'CHIA' as ExchangeId,
  Mfund: 'MFUND' as ExchangeId,
  Algo: 'ALGO' as ExchangeId,
  Cmcx: 'CMCX' as ExchangeId,
  International: 'International' as ExchangeId,
  Xtsx: 'XTSX' as ExchangeId,
  Xnas: 'XNAS' as ExchangeId,
  Xase: 'XASE' as ExchangeId,
  Xnys: 'XNYS' as ExchangeId,
  Xtse: 'XTSE' as ExchangeId,
  Xtks: 'XTKS' as ExchangeId,
  Xjas: 'XJAS' as ExchangeId,
  Xhkg: 'XHKG' as ExchangeId,
  Xses: 'XSES' as ExchangeId,
  Xlon: 'XLON' as ExchangeId,
  Xpar: 'XPAR' as ExchangeId,
  Xmli: 'XMLI' as ExchangeId,
  Alxp: 'ALXP' as ExchangeId,
  Xswx: 'XSWX' as ExchangeId,
  Xvtx: 'XVTX' as ExchangeId,
  Tnla: 'TNLA' as ExchangeId,
  Xams: 'XAMS' as ExchangeId,
  Xbru: 'XBRU' as ExchangeId,
  Mlxb: 'MLXB' as ExchangeId,
  Vpxb: 'VPXB' as ExchangeId,
  Alxb: 'ALXB' as ExchangeId,
  Xetr: 'XETR' as ExchangeId,
  Xfra: 'XFRA' as ExchangeId,
  Arcx: 'ARCX' as ExchangeId,
  Xnze: 'XNZE' as ExchangeId,
  Ootc: 'OOTC' as ExchangeId,
  Tnlb: 'TNLB' as ExchangeId,
  Bats: 'BATS' as ExchangeId,
  Iexg: 'IEXG' as ExchangeId,
  Xjpx: 'XJPX' as ExchangeId,
  Xcnq: 'XCNQ' as ExchangeId,
  Xcbo: 'XCBO' as ExchangeId,
  Finr: 'FINR' as ExchangeId,
  Xsto: 'XSTO' as ExchangeId,
  Xmce: 'XMCE' as ExchangeId,
  Fndk: 'FNDK' as ExchangeId,
  Fnse: 'FNSE' as ExchangeId,
  Mabx: 'MABX' as ExchangeId,
  Xcse: 'XCSE' as ExchangeId,
  Fnis: 'FNIS' as ExchangeId,
  Xice: 'XICE' as ExchangeId,
  Xlat: 'XLAT' as ExchangeId,
  Forex: 'FOREX' as ExchangeId,
  Itbit: 'ITBIT' as ExchangeId
};
